import { css } from 'styled-components';
import { hCenterRow } from './hCenterRow';

export const fullCenterRow = css`
  ${hCenterRow};
  align-items: center;
`;
